import { http, httpFile } from './http_service';

//Get all
export function all(){
    return http().get('/vehiclecategories');
}
//Get all active
export function allActive(){
    return http().get('/vehiclecategories/active');
}
//Get Single
export function single(id){
    return http().get(`/vehiclecategories/${id}`);
}
//Add one
export function add(data){
    return http().post('/vehiclecategories', data)
}
//Update
export function update(id, data){
    return http().put(`/vehiclecategories/${id}`, data)
}
//Delete one
export function deleteSingle(id){
    return http().delete(`/vehiclecategories/${id}`);
}